import { makeApiRequest } from 'actions/api';
import { getUser } from 'actions/user';

import * as fromPantry from 'reducers/pantry';

import RequestService from 'services/RequestService';

export const BOOTSTRAP_PANTRY = 'BOOTSTRAP_PANTRY';
export const BOOTSTRAP_PANTRY_SUCCESS = 'BOOTSTRAP_PANTRY_SUCCESS';
export const BOOTSTRAP_PANTRY_ERROR = 'BOOTSTRAP_PANTRY_ERROR';

export const bootstrapPantry = () => async dispatch => {
  dispatch({ type: BOOTSTRAP_PANTRY });
  try {
    await dispatch(getUser());
    await dispatch(getCart());
    await dispatch(getProducts());
    dispatch({ type: BOOTSTRAP_PANTRY_SUCCESS });
  } catch (e) {
    dispatch({ type: BOOTSTRAP_PANTRY_ERROR });
  }
};

export const CREATE_CART = 'CREATE_CART';
export const CREATE_CART_REQUEST = 'CREATE_CART_REQUEST';
export const CREATE_CART_RESPONSE = 'CREATE_CART_RESPONSE';
export const CREATE_CART_ERROR = 'CREATE_CART_ERROR';

export const createCart = params =>
  makeApiRequest({
    requestType: CREATE_CART,
    method: RequestService.createCart,
    params,
  });

export const ADD_CART_ITEM = 'ADD_CART_ITEM';
export const ADD_CART_ITEM_REQUEST = 'ADD_CART_ITEM_REQUEST';
export const ADD_CART_ITEM_RESPONSE = 'ADD_CART_ITEM_RESPONSE';
export const ADD_CART_ITEM_ERROR = 'ADD_CART_ITEM_ERROR';

export const addCartItem = (productId, quantity = 1) => async (dispatch, getState) => {
  const state = getState();
  const cart = fromPantry.selectCart(state);
  if (cart.id) {
    return await dispatch(
      makeApiRequest({
        requestType: ADD_CART_ITEM,
        method: RequestService.updateCart,
        params: { cartId: cart.id, lineItem: { productId, quantity } },
      })
    );
  } else {
    return await dispatch(createCart({ lineItem: { productId } }));
  }
};

export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const REMOVE_CART_ITEM_REQUEST = 'REMOVE_CART_ITEM_REQUEST';
export const REMOVE_CART_ITEM_RESPONSE = 'REMOVE_CART_ITEM_RESPONSE';
export const REMOVE_CART_ITEM_ERROR = 'REMOVE_CART_ITEM_ERROR';

export const removeCartItem = productId => async (dispatch, getState) => {
  const state = getState();
  const cart = fromPantry.selectCart(state);
  const item = fromPantry.selectCartItem(state, productId);
  return await dispatch(
    makeApiRequest({
      requestType: REMOVE_CART_ITEM,
      method: RequestService.updateCart,
      params: {
        cartId: cart.id,
        lineItem: {
          productId,
          id: item.id,
          remove: true,
          quantity: item.quantity,
        },
      },
    })
  );
};

export const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM';
export const UPDATE_CART_ITEM_REQUEST = 'UPDATE_CART_ITEM_REQUEST';
export const UPDATE_CART_ITEM_RESPONSE = 'UPDATE_CART_ITEM_RESPONSE';
export const UPDATE_CART_ITEM_ERROR = 'UPDATE_CART_ITEM_ERROR';

export const updateCartItem = (id, params) => async (dispatch, getState) => {
  const state = getState();
  const cart = fromPantry.selectCart(state);
  return await dispatch(
    makeApiRequest({
      requestType: UPDATE_CART_ITEM,
      method: RequestService.updateCart,
      params: { lineItem: { ...params, id }, cartId: cart.id },
    })
  );
};

export const GET_CART = 'GET_CART';
export const GET_CART_REQUEST = 'GET_CART_REQUEST';
export const GET_CART_RESPONSE = 'GET_CART_RESPONSE';
export const GET_CART_ERROR = 'GET_CART_ERROR';

export const getCart = () =>
  makeApiRequest({
    requestType: GET_CART,
    method: RequestService.getCart,
  });

export const GET_CHARGED_CART = 'GET_CHARGED_CART';
export const GET_CHARGED_CART_REQUEST = 'GET_CHARGED_CART_REQUEST';
export const GET_CHARGED_CART_RESPONSE = 'GET_CHARGED_CART_RESPONSE';
export const GET_CHARGED_CART_ERROR = 'GET_CHARGED_CART_ERROR';

export const getChargedCart = id =>
  makeApiRequest({
    requestType: GET_CHARGED_CART,
    method: RequestService.getChargedCart,
    params: { id },
  });

export const UPDATE_CART = 'UPDATE_CART';
export const UPDATE_CART_REQUEST = 'UPDATE_CART_REQUEST';
export const UPDATE_CART_RESPONSE = 'UPDATE_CART_RESPONSE';
export const UPDATE_CART_ERROR = 'UPDATE_CART_ERROR';

export const updateCart = params => async (dispatch, getState) => {
  const cart = fromPantry.selectCart(getState());
  return await dispatch(
    makeApiRequest({
      requestType: UPDATE_CART,
      method: RequestService.updateCart,
      params: { ...params, cartId: cart.id },
    })
  );
};

export const GET_INVENTORY = 'GET_INVENTORY';
export const GET_INVENTORY_REQUEST = 'GET_INVENTORY_REQUEST';
export const GET_INVENTORY_RESPONSE = 'GET_INVENTORY_RESPONSE';
export const GET_INVENTORY_ERROR = 'GET_INVENTORY_ERROR';

export const getInventory = productIds =>
  makeApiRequest({
    requestType: GET_INVENTORY,
    method: RequestService.getInventory,
    params: { productIds },
  });

export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR';
export const GET_PRODUCTS_RESPONSE = 'GET_PRODUCTS_RESPONSE';

export const getProducts = () =>
  makeApiRequest({
    requestType: GET_PRODUCTS,
    method: RequestService.getProducts,
  });

export const CREATE_CHECKOUT = 'CREATE_CHECKOUT';
export const CREATE_CHECKOUT_REQUEST = 'CREATE_CHECKOUT_REQUEST';
export const CREATE_CHECKOUT_RESPONSE = 'CREATE_CHECKOUT_RESPONSE';
export const CREATE_CHECKOUT_ERROR = 'CREATE_CHECKOUT_ERROR';

export const createCheckout = cardToken => async (dispatch, getState) => {
  const cart = fromPantry.selectCart(getState());
  return await dispatch(
    makeApiRequest({
      requestType: CREATE_CHECKOUT,
      method: RequestService.createCheckout,
      params: { cardToken, cartId: cart.id },
    })
  );
};
